<div data-cy="house-age">
  <div [formGroup]="control" class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.houseDetails.steps.houseAge.title' | translate"
      data-cy="house-age-title"
    ></ife-title>

    <div class="flex flex-wrap checkboxPadding justify-center">
      <ife-checkbox
        [id]="houseAge.lessThan10Years"
        [attr.data-cy]="houseAge.lessThan10Years"
        class="w-full sm:w-auto"
        [value]="houseAge.lessThan10Years"
        formControlName="value"
        [image]="'./assets/evc/img/-10.svg'"
        [caption]="'modules.evcQuote.steps.houseDetails.steps.houseAge.options.lessThan10Years' | translate"
      >
      </ife-checkbox>
      <ife-checkbox
        [id]="houseAge.moreThan10Years"
        [attr.data-cy]="houseAge.moreThan10Years"
        class="w-full sm:w-auto"
        [value]="houseAge.moreThan10Years"
        formControlName="value"
        [image]="'./assets/evc/img/+10.svg'"
        [caption]="'modules.evcQuote.steps.houseDetails.steps.houseAge.options.moreThan10Years' | translate"
      >
      </ife-checkbox>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
